const olderInstitution = {
    path: "/olderInstitution", // 主体
    name: "olderInstitution",
    redirect: "/oldderManagement",
    component: () => import("../views/olderInstitution/main"),
    children: [
        {
            path: "/OlderWorkbench",
            name: "OlderWorkbench",
            meta: {
                title: "工作台"
            },
            component: () =>
                import("../views/olderInstitution/oldderManagement/OlderWorkbench.vue")
        },
        {
            path: "/oldderManagement",
            name: "oldderManagement",
            meta: {
                title: "老人管理"
            },
            component: () =>
                import("../views/olderInstitution/oldderManagement/index.vue"),
            redirect: "/OlderInfo",
            children: [
                {
                    path: "/OlderInfo",
                    name: "olderInfo",
                    meta: {
                        title: "老人信息管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/oldderManagement/OlderInfo.vue")
                },
                {
                    path: "/HealthInformationManagement",
                    name: "HealthInformationManagement",
                    meta: {
                        title: "健康信息管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/oldderManagement/healthInformationManagement/index.vue")
                },
                {
                    path: "/healthAssessment",
                    name: "healthAssessment",
                    meta: {
                        title: "健康评估"
                    },
                    component: () =>
                        import("../views/olderInstitution/oldderManagement/healthAssessment/index.vue"),

                    children: [
                        {
                            path: "/HealthInfo",
                            name: "healthInfo",
                            meta: {
                                title: "健康信息管理"
                            },
                            component: () =>
                                import("../views/olderInstitution/oldderManagement/healthAssessment/HealthInfo.vue")
                        },
                        {
                            path: "/AssessmentReport",
                            name: "assessmentReport",
                            meta: {
                                title: "评估报告"
                            },
                            component: () =>
                                import("../views/olderInstitution/oldderManagement/healthAssessment/AssessmentReport.vue")
                        },
                        {
                            path: "/MedicalInfo",
                            name: "medicalInfo",
                            meta: {
                                title: "医疗信息"
                            },
                            component: () =>
                                import("../views/olderInstitution/oldderManagement/healthAssessment/MedicalInfo.vue")
                        },
                        {
                            path: "/BookingABed",
                            name: "BookingABed",
                            meta: {
                                title: "预约信息"
                            },
                            component: () =>
                                import("../views/olderInstitution/oldderManagement/makeAnAppointment.vue")
                        }
                    ]
                },
                {
                    path: "/olderServerList",
                    name: "olderServerList",
                    meta: {
                        title: "老人服务工单"
                    },
                    component: () =>
                        import("../views/olderInstitution/oldderManagement/olderServerList/index.vue"),

                    children: [
                        {
                            path: "/dailyCare",
                            name: "dailyCare",
                            meta: {
                                title: "生活照料"
                            },
                            component: () =>
                                import("../views/olderInstitution/oldderManagement/olderServerList/dailyCare/index.vue"),
                            redirect: "/CarePlan",
                            children: [
                                {
                                    path: "/CarePlan",
                                    name: "CarePlan",
                                    meta: {
                                        title: "新增照料"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/oldderManagement/olderServerList/dailyCare/CarePlan.vue")
                                },

                                {
                                    path: "/OneTouchCall",
                                    name: "OneTouchCall",
                                    meta: {
                                        title: "一键呼叫"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/oldderManagement/olderServerList/dailyCare/OneTouchCall.vue")
                                },
                                {
                                    path: "/remoteTreatment",
                                    name: "remoteTreatment",
                                    meta: {
                                        title: "远程诊疗"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/oldderManagement/olderServerList/dailyCare/remoteTreatment.vue")
                                },
                                {
                                    path: "/emergencyRescue",
                                    name: "emergencyRescue",
                                    meta: {
                                        title: "紧急求援"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/oldderManagement/olderServerList/dailyCare/emergencyRescue.vue")
                                },
                                {
                                    path: "/positionRegularly",
                                    name: "positionRegularly",
                                    meta: {
                                        title: "定时定位"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/oldderManagement/olderServerList/dailyCare/positionRegularly.vue")
                                },
                                {
                                    path: "/spiritCaring",
                                    name: "spiritCaring",
                                    meta: {
                                        title: "精神关怀"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/oldderManagement/olderServerList/dailyCare/spiritCaring.vue")
                                }
                            ]
                        },
                        {
                            path: "/DietaryManagement",
                            name: "DietaryManagement",
                            meta: {
                                title: "膳食管理"
                            },
                            component: () =>
                                import("../views/olderInstitution/oldderManagement/olderServerList/DietaryManagement.vue")
                        },
                        {
                            path: "/ActivitieManagement",
                            name: "ActivitieManagement",
                            meta: {
                                title: "活动管理"
                            },
                            component: () =>
                                import("../views/olderInstitution/oldderManagement/olderServerList/ActivitieManagement.vue")
                        }
                    ]
                },
                // {
                //   path: "/InOutManagement",
                //   name: "InOutManagement",
                //   meta: {
                //     title: "出入管理"
                //   },
                //   component: () =>
                //     import("../views/olderInstitution/oldderManagement/InOutManagement/index.vue"),
                //
                // },
                {
                    path: "/qingjia",
                    name: "qingjia",
                    meta: {
                        title: "请假管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/oldderManagement/InOutManagement/qingjia.vue")
                },
                {
                    path: "/AccessRecords",
                    name: "AccessRecords",
                    meta: {
                        title: "出入记录"
                    },
                    component: () =>
                        import("../views/olderInstitution/oldderManagement/InOutManagement/index.vue")
                },
                {
                    path: "/OlderFeedback",
                    name: "OlderFeedback",
                    meta: {
                        title: "老人反馈"
                    },
                    component: () =>
                        import("../views/olderInstitution/oldderManagement/OlderFeedback.vue")
                }
            ]
        },
        {
            path: "/YuanBuManagement",
            name: "YuanBuManagement",
            meta: {
                title: "院部管理"
            },
            component: () =>
                import("../views/olderInstitution/YuanBuManagement/index.vue"),

            children: [
                {
                    path: "/YuanBuInfo",
                    name: "YuanBuInfo",
                    meta: {
                        title: "院部信息"
                    },
                    component: () =>
                        import("../views/olderInstitution/YuanBuManagement/YuanBuInfo.vue")
                },
                {
                    path: "/staffManagement",
                    name: "staffManagement",
                    meta: {
                        title: "员工管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/YuanBuManagement/staffManagement/index.vue"),

                    children: [
                        {
                            path: "/StaffInfo",
                            name: "StaffInfo",
                            meta: {
                                title: "员工信息"
                            },
                            component: () =>
                                import("../views/olderInstitution/YuanBuManagement/staffManagement/StaffInfo.vue")
                        },
                        {
                            path: "/attendanceManagement",
                            name: "attendanceManagement",
                            meta: {
                                title: "考勤管理"
                            },
                            component: () =>
                                import("../views/olderInstitution/YuanBuManagement/staffManagement/attendanceManagement/index.vue"),
                            // redirect: '/SetAttendanceTime',
                            children: [
                                {
                                    path: "/SetAttendanceTime",
                                    name: "SetAttendanceTime",
                                    meta: {
                                        title: "考勤时间设置"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/YuanBuManagement/staffManagement/attendanceManagement/SetAttendanceTime.vue")
                                },
                                {
                                    path: "/AttendanceStatistics",
                                    name: "AttendanceStatistics",
                                    meta: {
                                        title: "考勤统计"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/YuanBuManagement/staffManagement/attendanceManagement/AttendanceStatistics.vue")
                                },
                                {
                                    path: "/AskForLeaveManagement",
                                    name: "AskForLeaveManagement",
                                    meta: {
                                        title: "请假管理"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/YuanBuManagement/staffManagement/attendanceManagement/AskForLeaveManagement.vue")
                                },
                                {
                                    path: "/WorkforceManagement",
                                    name: "WorkforceManagement",
                                    meta: {
                                        title: "排班管理"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/YuanBuManagement/staffManagement/attendanceManagement/WorkforceManagement.vue")
                                },
                                {
                                    path: "/schedulingApplication",
                                    name: "schedulingApplication",
                                    meta: {
                                        title: "排班申请"
                                    },
                                    component: () =>
                                        import("../views/olderInstitution/YuanBuManagement/staffManagement/attendanceManagement/schedulingApplication.vue")
                                }
                            ]
                        }
                    ]
                },
                {
                    path: "/FoodManagement",
                    name: "FoodManagement",
                    meta: {
                        title: "食品管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/YuanBuManagement/FoodManagement/index.vue"),
                    // redirect: '/FoodInfo',
                    children: [
                        {
                            path: "/FoodInfo",
                            name: "FoodInfo",
                            meta: {
                                title: "菜品信息"
                            },
                            component: () =>
                                import("../views/olderInstitution/YuanBuManagement/FoodManagement/foodmation.vue")
                        },
                        {
                            path: "/WeeklyMenu",
                            name: "WeeklyMenu",
                            meta: {
                                title: "每周菜单"
                            },
                            component: () =>
                                import("../views/olderInstitution/YuanBuManagement/FoodManagement/jgmenuWeekly.vue")
                        }
                    ]
                },
                {
                    path: "/ItemManagement",
                    name: "ItemManagement",
                    meta: {
                        title: "物品管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/YuanBuManagement/ItemManagement.vue")
                },
                {
                    path: "/suppotFacity",
                    name: "suppotFacity",
                    meta: {
                        title: "配套设施"
                    },
                    component: () =>
                        import("../views/olderInstitution/YuanBuManagement/suppotFacity.vue")
                },
                {
                    path: "/VisitorManagement",
                    name: "VisitorManagement",
                    meta: {
                        title: "访客管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/YuanBuManagement/VisitorManagement/index.vue"),
                    children: [
                        {
                            path: "/VisitorApply",
                            name: "VisitorApply",
                            meta: {
                                title: "访客申请"
                            },
                            component: () =>
                                import("../views/olderInstitution/YuanBuManagement/VisitorManagement/VisitorApply.vue")
                        },
                        {
                            path: "/VisitingRegistration",
                            name: "VisitingRegistration",
                            meta: {
                                title: "探访登记"
                            },
                            component: () =>
                                import("../views/olderInstitution/YuanBuManagement/VisitorManagement/VisitingRegistration.vue")
                        },
                        {
                            path: "/VisitStatistics",
                            name: "VisitStatistics",
                            meta: {
                                title: "探访日统计"
                            },
                            component: () =>
                                import("../views/olderInstitution/YuanBuManagement/VisitorManagement/VisitStatistics.vue")
                        }
                    ]
                },
                {
                    path: "/VolunteerManagement",
                    name: "VolunteerManagement",
                    meta: {
                        title: "志愿管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/YuanBuManagement/VolunteerManagement.vue")
                },
                {
                    path: "/DonationManagement",
                    name: "DonationManagement",
                    meta: {
                        title: "捐赠管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/YuanBuManagement/DonationManagement.vue")
                },
                {
                    path: "/expense",
                    name: "expense",
                    meta: {
                        title: "费用管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/expense/expense.vue")
                },

                {
                    path: "/assets",
                    name: "assets",
                    meta: {
                        title: "固定资产管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/newAssets/newAssets.vue")
                },
                {
                    path: "/record",
                    name: "record",
                    meta: {
                        title: "档案管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/record/record.vue")
                },
                {
                    path: "/billing",
                    name: "billing",
                    mate: {
                        title: "机构养老收支账管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/billing/index")
                },
                {
                    path: "/TrainingManagement",
                    name: "TrainingManagement",
                    meta: {
                        title: "培训管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/YuanBuManagement/TrainingManagement.vue")
                }
            ]
        },
        {
            path: "/civilManagement",
            name: "civilManagement",
            meta: {
                title: "民政管理"
            },
            component: () =>
                import("../views/olderInstitution/civilManagement/index.vue"),
            children: [
                {
                    path: "/CivilFile",
                    name: "CivilFile",
                    meta: {
                        title: "民政文件"
                    },
                    component: () =>
                        import("../views/olderInstitution/civilManagement/CivilFile.vue")
                },
                {
                    path: "/safetyInspection",
                    name: "safetyInspection",
                    meta: {
                        title: "安全巡检"
                    },
                    component: () =>
                        import("../views/olderInstitution/civilManagement/safetyInspection.vue")
                },
                {
                    path: "/RectificationRecords",
                    name: "RectificationRecords",
                    meta: {
                        title: "整改记录"
                    },
                    component: () =>
                        import("../views/olderInstitution/civilManagement/RectificationRecord.vue")
                },
                {
                    path: "/SubsidiesAnnouncement",
                    name: "SubsidiesAnnouncement",
                    meta: {
                        title: "补贴公告"
                    },
                    component: () =>
                        import("../views/olderInstitution/civilManagement/SubsidiesAnnouncement.vue")
                },
                {
                    path: "/subsidyManagement",
                    name: "subsidyManagement",
                    meta: {
                        title: "补贴管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/civilManagement/subsidyManagement/index.vue"),
                    children: [
                        {
                            path: "/applicationForOperatingSubsidy",
                            name: "applicationForOperatingSubsidy",
                            meta: {
                                title: "运营补贴申请"
                            },
                            component: () =>
                                import("../views/olderInstitution/civilManagement/subsidyManagement/applicationForOperatingSubsidy.vue")
                        },
                        {
                            path: "/carerSubsidy",
                            name: "carerSubsidy",
                            meta: {
                                title: "护理员补贴"
                            },
                            component: () =>
                                import("../views/olderInstitution/civilManagement/subsidyManagement/carerSubsidy.vue")
                        },
                        {
                            path: "/theConstructionOfSubsidies",
                            name: "theConstructionOfSubsidies",
                            meta: {
                                title: "建设补贴"
                            },
                            component: () =>
                                import("../views/olderInstitution/civilManagement/subsidyManagement/theConstructionOfSubsidies.vue")
                        },
                        {
                            path: "/bedOperationSubsidy",
                            name: "bedOperationSubsidy",
                            meta: {
                                title: "床位运营补贴"
                            },
                            component: () =>
                                import("../views/olderInstitution/civilManagement/subsidyManagement/bedOperationSubsidy.vue")
                        }
                    ]
                }
            ]
        },
        {
            path: "/theDataDictionary",
            name: "theDataDictionary",
            meta: {
                title: "数据字典"
            },
            component: () =>
                import("../views/olderInstitution/dataManagement/theDataDictionary/index.vue"),
            children: [
                {
                    path: "/BuildingManagement",
                    name: "BuildingManagement",
                    meta: {
                        title: "楼栋管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/BuildingManagement.vue")
                },

                {
                    path: "/theServiceName",
                    name: "theServiceName",
                    meta: {
                        title: "服务名称"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/theServiceName.vue")
                },
                {
                    path: "/serviceType",
                    name: "serviceType",
                    meta: {
                        title: "服务类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/serviceType.vue")
                },
                {
                    path: "/activityType",
                    name: "activityType",
                    meta: {
                        title: "活动类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/activityType.vue")
                },
                {
                    path: "/theOldManType",
                    name: "theOldManType",
                    meta: {
                        title: "老人类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/theOldManType.vue")
                },
                {
                    path: "/gradeOfNursingBed",
                    name: "gradeOfNursingBed",
                    meta: {
                        title: "护理床位等级"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/gradeOfNursingBed.vue")
                },
                {
                    path: "/dishTaste",
                    name: "dishTaste",
                    meta: {
                        title: "菜品口味"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/dishTaste.vue")
                },
                {
                    path: "/diningType",
                    name: "diningType",
                    meta: {
                        title: "餐饮类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/diningType.vue")
                },
                {
                    path: "/basicServices",
                    name: "basicServices",
                    meta: {
                        title: "基础服务"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/basicServices.vue")
                },
                {
                    path: "/eventAlertCategory",
                    name: "eventAlertCategory",
                    meta: {
                        title: "事件提醒类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/eventAlertCategory.vue")
                },
                {
                    path: "/personnelType",
                    name: "personnelType",
                    meta: {
                        title: "人员类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/personnelType.vue")
                },
                {
                    path: "/rawMaterialsToMaintain",
                    name: "rawMaterialsToMaintain",
                    meta: {
                        title: "原料维护"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/rawMaterialsToMaintain.vue")
                },
                {
                    path: "/CertifiType",
                    name: "CertifiType",
                    meta: {
                        title: "证书类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/CertifiType.vue")
                },
                {
                    path: "/nameOfTheCertificate",
                    name: "nameOfTheCertificate",
                    meta: {
                        title: "证书名称"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/nameOfTheCertificate.vue")
                },
                {
                    path: "/ItemName",
                    name: "ItemName",
                    meta: {
                        title: "物品名称"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/ItemName.vue")
                },
                {
                    path: "/bedType",
                    name: "bedType",
                    meta: {
                        title: "床位类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/bedType.vue")
                },
                {
                    path: "/inspectionType",
                    name: "inspectionType",
                    meta: {
                        title: "巡检类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/inspectionType.vue")
                },
                {
                    path: "/schedulingTime",
                    name: "schedulingTime",
                    meta: {
                        title: "排班时间"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/schedulingTime.vue")
                },
                {
                    path: "/itemType",
                    name: "itemType",
                    meta: {
                        title: "物品类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/itemType.vue")
                },
                {
                    path: "/reportingInterval",
                    name: "reportingInterval",
                    meta: {
                        title: "申报区间"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/reportingInterval.vue")
                },
                {
                    path: "/visitorsType",
                    name: "visitorsType",
                    meta: {
                        title: "访客类型"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/visitorsType.vue")
                },
                {
                    path: "/relationOlder",
                    name: "relationOlder",
                    meta: {
                        title: "与老人关系"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/relationOlder.vue")
                },
                {
                    path: "/drugsManagement",
                    name: "drugsManagement",
                    meta: {
                        title: "药品管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/drugsManagement.vue")
                },
                {
                    path: "/departmentManagement",
                    name: "departmentManagement",
                    meta: {
                        title: "部门管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/departmentManagement.vue")
                },
                {
                    path: "/postManagement",
                    name: "postManagement",
                    meta: {
                        title: "岗位管理"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/postManagement.vue")
                },
                {
                    path: "/TrainingSkills",
                    name: "TrainingSkills",
                    meta: {
                        title: "培训技能"
                    },
                    component: () =>
                        import("../views/olderInstitution/dataManagement/theDataDictionary/TrainingSkills.vue")
                }
            ]
        }
    ]
}
export default olderInstitution
